interface CloudinaryUploadResponse {
  public_id: string;
  format: string;
  width: number;
  height: number;
}

export const cloudinaryService = {
  async upload(file: File, entity?: string) {
    const formData = new FormData();

    const meta = `source=new-backoffice|env=${import.meta.env.PROD ? "production" : "develop"}${entity ? `|entity=${entity}` : ""}`;
    formData.append("upload_preset", "pbejhvte");
    formData.append("metadata", meta);
    formData.append("file", file);
    const resp = await fetch(
      "https://api.cloudinary.com/v1_1/tysdo/image/upload",
      {
        method: "POST",
        body: formData,
      },
    );
    if (!resp.ok) {
      const errBody = await resp.json().catch(() => ({}));
      throw new Error(
        (errBody as { error?: { message?: string } })?.error?.message ??
          `Cloudinary upload failed: ${resp.status}`,
      );
    }
    const response: CloudinaryUploadResponse = await resp.json();
    const picture = response.public_id + "." + response.format;

    const cropData = {
      x: 0,
      y: 0,
      width: response.width,
      height: response.height,
    };

    const pictureOptimized = `https://res.cloudinary.com/tysdo/image/upload/c_crop,x_${Math.round(cropData.x)},y_${Math.round(cropData.y)},w_${Math.round(cropData.width)},h_${Math.round(cropData.height)}/q_auto:eco/${picture}`;

    return pictureOptimized;
  },
  async uploadPdf(file: File, entity?: string) {
    const formData = new FormData();
    const meta = `source=new-backoffice|env=${import.meta.env.PROD ? "production" : "develop"}${entity ? `|entity=${entity}` : ""}`;
    formData.append("file", file);
    formData.append("upload_preset", "pbejhvte");
    formData.append("metadata", meta);
    formData.append("resource_type", "raw");
    formData.append("folder", "privaterooms");
    const resp = await fetch(
      "https://api.cloudinary.com/v1_1/tysdo/raw/upload",
      {
        method: "POST",
        body: formData,
      },
    );
    const response = await resp.json();
    const fileName = response.public_id;

    const url = `https://res.cloudinary.com/tysdo/raw/upload/${fileName}`;
    return url;
  },
};
